/**
 * Filter function used to filter out users in Comms management page.
 */
(function() {
    'use strict';

    angular.module('app').filter('userFilter', function() {

        return function(input, statuses) {
            if (!statuses || statuses.length === 0) return input;
            var out = [];
            angular.forEach(input, function (item) {
                angular.forEach(statuses, function (status) {
                    if(item.createdByXmsLoginId){
                        if (item.createdByXmsLoginId === status.type) {
                            out.push(item);
                        }
                    }
                });
            });
            return out;
        }
    });

}());